module.exports = __webpack_public_path__ + "static/media/professional_1.d7ef44d5.svg";